/**
 *
 * @page 用户中心/我的消息/系统消息
 *
 **/

import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import React from 'react';
import './SystemMsg.scss';
import { Pagination } from 'antd';
import { DeleteFilled, MailFilled } from '@ant-design/icons';
import { observer, inject } from 'mobx-react';
import BaseListWrap from '&/components/BaseListWrap';
import useMessage from '@/utils/customHooks/useMessage';

function SystemMsg(props) {
    const [
        title,
        msgList,
        loading,
        total,
        queryForm,
        onPageChange,
        deleteMsg,
        markAsRead,
    ] = useMessage(2, props.persenCenter.queryUnreadAmount);

    const headerRight = (
        <button className="text-btn" onClick={() => markAsRead()}>
            {intl.get('userCenter.markAllRead')}
        </button>
    );

    const messageTarget = data => {
        if (!data.param1) return;
        try {
            const PARAMS = JSON.parse(data.param1);
            if (PARAMS?.url) {
                return (
                    <a
                        className="native-link"
                        target="_blank"
                        rel="noreferrer"
                        href={PARAMS.url}>
                        {intl.get('userCenter.clickHere')}
                    </a>
                );
            }
        } catch {}
    };

    const MessageItem = ({ data }) => (
        <section
            className="message-item"
            onClick={() => markAsRead([data.id], data.status)}>
            <MailFilled
                className={`read-icon ${data.status === 2 ? 'unred' : ''}`}
            />
            <div className="message-main">
                <div className="message-content">
                    {data.content}
                    {messageTarget(data)}
                </div>
                <div className="message-aside">
                    <div className="time">{data.createDate}</div>
                    {/*  <i className="text-btn filled"></i> */}
                    <DeleteFilled
                        className="text-btn"
                        onClick={e => deleteMsg(e, data.id)}
                    />
                </div>
            </div>
        </section>
    );

    return (
        <BasePageWrap type="card" title={title} headerRight={headerRight}>
            <BaseListWrap isLoading={loading} isEmpty={!!msgList.length}>
                {msgList.map(e => (
                    <MessageItem key={e.id} data={e} />
                ))}

                <Pagination
                    size="small"
                    current={queryForm.page}
                    onChange={onPageChange}
                    pageSize={queryForm.limit}
                    total={total}
                    showSizeChanger={true}
                    showTotal={total => intl.get('base.total', { total })}
                />
            </BaseListWrap>
        </BasePageWrap>
    );
}

export default inject('persenCenter')(observer(SystemMsg));
